/**
 * Resolve the device-pixel ratio with an SSR/test-friendly fallback.
 *
 * Returns 1 when `window` is undefined (SSR / no-DOM environments) or when
 * `window.devicePixelRatio` is 0/falsy. Used by raster pipelines (smiley,
 * textbox SVG-foreignObject) to size physical pixels for crisp output on
 * high-DPI displays without coupling to a global.
 */
export function getDpr(): number {
  return (typeof window !== 'undefined' ? window.devicePixelRatio : 1) || 1;
}
